import { useInView } from 'react-intersection-observer'
import React from 'react'

const Content = ({ children, height, shouldRender }) => {
  if (shouldRender) return <div>{children}</div>
  return <div style={{ height }} />
}

const RenderOnScreen = ({ children, disabled, initialHeight, id }) => {
  const innerRef = React.useRef(null)
  const [height, setHeight] = React.useState(initialHeight || 50)
  const [wrapperRef, isOnScreen] = useInView({ threshold: 0 })
  const [shouldRender, setShouldRender] = React.useState(isOnScreen)

  React.useEffect(() => {
    setHeight(innerRef.current?.offsetHeight)
    setShouldRender(isOnScreen)
  }, [isOnScreen])

  if (disabled) return children

  return (
    <div ref={wrapperRef} id={id} className="renderOnScreen" style={{ minHeight: !isOnScreen && height + 'px' }}>
      <div ref={innerRef}>
        <Content shouldRender={shouldRender} height={height}>
          {children}
        </Content>
      </div>
    </div>
  )
}

export default RenderOnScreen
